import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper"
import * as programCrud from '../../../../crud/program.crud';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';


export const getBatchFormFields = (fields, replyFields, intl) => {

    const formFields = [
        {
            caption: fields.Reference.label,
            dataField: 'reference',
            required: fields.Reference.required,
            dataType: 'string',
            min: 1,
            max: 250
        }
    ];

    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'type',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }

    if (fields.PlannedCompletion.visible) {
        formFields.push({
            caption: fields.PlannedCompletion.label,
            dataField: 'plannedcompletiondatedisplay',
            required: fields.PlannedCompletion.required,
            dataType: 'date'
        })
    }
    if (fields.Reason.visible) {
        formFields.push({
            caption: fields.Reason.label,
            dataField: 'reasonchanged',
            required: fields.Reason.required,
            dataType: 'long-string'
        })
    }
    if (fields.Change.visible) {
        formFields.push({
            caption: fields.Change.label,
            dataField: 'details',
            required: fields.Change.required,
            dataType: 'long-string'
        })
    }
    if (fields.MainProgress.visible) {
        formFields.push({
            caption: fields.MainProgress.label,
            dataField: 'mainprogress',
            required: fields.MainProgress.required,
            dataType: 'long-string'
        })
    }
    if (fields.KeyActivities.visible) {
        formFields.push({
            caption: fields.KeyActivities.label,
            dataField: 'keyactivities',
            required: fields.KeyActivities.required,
            dataType: 'long-string'
        })
    }
    if (fields.Summary.visible) {
        formFields.push({
            caption: fields.Summary.label,
            dataField: 'summarycritical',
            required: fields.Summary.required,
            dataType: 'long-string'
        })
    }
    if (fields.Changes.visible) {
        formFields.push({
            caption: fields.Changes.label,
            dataField: 'mainchanges',
            required: fields.Changes.required,
            dataType: 'long-string'
        })
    }
    if (fields.Compensation.visible) {
        formFields.push({
            caption: fields.Compensation.label,
            dataField: 'compensationevents',
            required: fields.Compensation.required,
            dataType: 'long-string'
        })
    }


    if (replyFields.Status.visible) {
        formFields.push({
            caption: replyFields.Status.label,
            dataField: 'status',
            required: replyFields.Status.required,
            dataType: 'list',
            options: {
                dataSource: replyFields.Status.replyOptions,
                valueExpr: 'field',
                displayExpr: 'display'
            },
            isReplyField: true
        })
    }

    if (replyFields.RejectReasons.visible) {
        replyFields.RejectReasons.rejectOptions.forEach(opt => {
            formFields.push({
                caption: opt.display,
                dataField: opt.field,
                required: true,
                dataType: 'integer',
                max: 1,
                min: 0,
                isReplyField: true
            })
        });
    }
    if (replyFields.Comments.visible) {
        formFields.push({
            caption: replyFields.Comments.label,
            dataField: 'comments',
            required: replyFields.Comments.required,
            dataType: 'long-string',
            isReplyField: true
        })
    }
    return formFields;
}



class ProgrammeList extends BaseListPage {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;
        if (this.props.workflowItem.replyEnabled && replyFields.Status.replyOptions) {
            this.replyOptionsQA = replyFields.Status.replyOptions.reduce((obj, item) => ({ ...obj, [item.field]: item.display }), {});
        }

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl);
        this.state = {
            notifications: null,
            tags: null
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchPrograms();
    }

    fetchPrograms = async () => {
        const { companyid, projectid, contractid } = this.props.contract;
        const { data: programs } = await programCrud.getContractPrograms(companyid, projectid, contractid, this.props.accessibleWfIds);
        const programList = notificationAggregateListTagsFilter(JSON.parse(programs.aggregatelist));

        const programListFiltered = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
            programList : programList.filter(ntf => ntf.showtasknotification === 1);

        let tagFilters = notificationUniqueTagsFilter(JSON.parse(programs.uniquetags));
        this.setState({ notifications: programListFiltered, tags: tagFilters });
    }

    getFormConfig = () => {
        const { fields, contract } = this.props;

    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.programid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.status) {
            case 'Awaiting Acceptance':
            case 'ADAP':
                badgeVariant = 'warning';
                break;
            case 'Not Communicated':
                badgeVariant = 'secondary';
                break;
            case 'Not Accepted':
            case 'NOT_ACCEPTED':
            case 'NOT_ACCEPTED_RESUBMIT':
                badgeVariant = 'danger';
                break;
            case 'Communicated':
            case 'Accepted':
            case 'PDA':
            case 'ACCEPT':
            case 'ACCEPT_WITH_COMMENTS':
            case 'NO_REPLY_REQUIRED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        if (this.replyOptionsQA && this.replyOptionsQA.hasOwnProperty(rowData.status)) {
            return this.replyOptionsQA[rowData.status];
        }
        else {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
        }
    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }
        const { fields } = this.props.workflowItem;
        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { caption: fields.Reference.label, dataField: 'reference' },
            { resource: "GENERAL.FORMS.FIELD.SUBMISSION_DATE", dataField: "changeddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.SUBMITTED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.PLANNEDCOMPLETIONDATE", dataField: "plannedcompletiondate", dataType: 'date' },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },


        ];
        if (fields.Type.visible) {
            columns.push(
                { caption: fields.Type.label, dataField: "type", visible: false }
            );
        }
        if (this.props.globalResources.PROG_DEEMED_ACCEPTANCE_STARTS !== 'OFF') {
            columns.push(
                { resource: "CONTRACT.WF.PROGRAM.FIELD.DEEM_DATE", dataField: "deemedacceptancedate", dataType: 'date' }
            );
        }
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));


        if (this.props.workflowItem.replyEnabled) {
            columns.splice(4, 0,
                { resource: "GENERAL.FORMS.FIELD.REPLY_REQUIRED", dataField: "replyrequireddate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.REPLY_DATE", dataField: "replydate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_BY", dataField: "draftreplyby", visible: false },
                { resource: "GENERAL.FORMS.FIELD.COMMENTS", dataField: "comments", isHtml: true },
                { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false }

            );
        }
        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={programCrud.importPrograms}
                        batchDeleteEndpoint={programCrud.deleteProgramDrafts}
                        batchCommunicateEndpoint={programCrud.communicateProgramDrafts}
                        onBatchRecordsUpdated={this.fetchPrograms}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="programid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(ProgrammeList);
